const imageUrlBuilder = require('@sanity/image-url')
const sanityClient = require('@sanity/client')
const client = sanityClient({
  projectId: 'iywruikl',
  dataset: 'production',
  useCdn: false,
})

const listingQUery = '*[_type == "posts"] {title,_id,slug,description,socialImage,author->,blogCategory->,date,featured,content,readTime,graphTags,tags}'
const builder = imageUrlBuilder(client);

exports.generateImageUrl = (source) => {
  return builder.image(source)
}

exports.getBlogs = async () => {
  return await client.fetch(listingQUery).then((posts) => {
    return posts;
  })
}
exports.getSiteSettings = async () => {
  return await client.getDocument('siteSettings').then((settings) => {
    return settings;
  })
}
